function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M105.61 45.74h72.158l36.4 63.049h41.569C246.274 47.342 193.172.291 129.077.291c-16.21 0-31.702 3.039-45.978 8.53l22.51 36.92",
  fill: "#006533"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M216.098 146.763l-38.33 66.39H81.112l-48.327-83.706 38.61-66.875-21.332-34.988C20.153 51.047.913 87.492.913 128.454c0 70.783 57.381 128.164 128.164 128.164 64.564 0 117.953-47.749 126.84-109.855h-39.82",
  fill: "#82B816"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M174.51 128.115c0 25.28-20.493 45.773-45.773 45.773-25.28 0-45.772-20.493-45.772-45.773 0-25.28 20.493-45.773 45.772-45.773 25.28 0 45.773 20.493 45.773 45.773",
  fill: "#006532"
});

function SvgGradle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 257",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid"
  }, props), _ref, _ref2, _ref3);
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjU2IDI1NyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWlkWU1pZCI+PHBhdGggZD0iTTEwNS42MSA0NS43NGg3Mi4xNThsMzYuNCA2My4wNDloNDEuNTY5QzI0Ni4yNzQgNDcuMzQyIDE5My4xNzIuMjkxIDEyOS4wNzcuMjkxYy0xNi4yMSAwLTMxLjcwMiAzLjAzOS00NS45NzggOC41M2wyMi41MSAzNi45MiIgZmlsbD0iIzAwNjUzMyIvPjxwYXRoIGQ9Ik0yMTYuMDk4IDE0Ni43NjNsLTM4LjMzIDY2LjM5SDgxLjExMmwtNDguMzI3LTgzLjcwNiAzOC42MS02Ni44NzUtMjEuMzMyLTM0Ljk4OEMyMC4xNTMgNTEuMDQ3LjkxMyA4Ny40OTIuOTEzIDEyOC40NTRjMCA3MC43ODMgNTcuMzgxIDEyOC4xNjQgMTI4LjE2NCAxMjguMTY0IDY0LjU2NCAwIDExNy45NTMtNDcuNzQ5IDEyNi44NC0xMDkuODU1aC0zOS44MiIgZmlsbD0iIzgyQjgxNiIvPjxwYXRoIGQ9Ik0xNzQuNTEgMTI4LjExNWMwIDI1LjI4LTIwLjQ5MyA0NS43NzMtNDUuNzczIDQ1Ljc3My0yNS4yOCAwLTQ1Ljc3Mi0yMC40OTMtNDUuNzcyLTQ1Ljc3MyAwLTI1LjI4IDIwLjQ5My00NS43NzMgNDUuNzcyLTQ1Ljc3MyAyNS4yOCAwIDQ1Ljc3MyAyMC40OTMgNDUuNzczIDQ1Ljc3MyIgZmlsbD0iIzAwNjUzMiIvPjwvc3ZnPgo=";
export { SvgGradle as ReactComponent };